import React from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { Button } from '@swiggy-private/dls-web-core/dist/components/Button';
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
import style from '../../ActionMenu.module.scss';
import Routes from '@/constants/Routes';
const DuplicateModalContent = ({ closeModal, campaignId, }) => {
    const navigate = useNavigate();
    const handleDuplicate = () => {
        closeModal();
        const params = {
            mode: CampaignWriteModeEnum.DUPLICATE,
        };
        navigate({
            pathname: Routes.INSTAMART.CAMPAIGN_CREATE,
            search: `${createSearchParams(params)}`,
        }, { preventScrollReset: true });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_Highest_Emphasis, className: style.modalTitle }, "Duplicate your campaign?"),
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: style.modalText }, "Duplicating your campaign would take you away from details page to the campaign create flow, click on Duplicate Campaign to continue"),
        React.createElement("div", { className: style.modalButtons },
            React.createElement(TextButton, { onClick: closeModal, className: style.modalCancelButton, buttonSize: "medium", color: DlsColorTokens.primary }, "Cancel"),
            React.createElement("div", { className: style.modalPrimaryButton },
                React.createElement(Button, { variant: "primary", onClick: handleDuplicate }, "Duplicate Campaign")))));
};
export default DuplicateModalContent;
